module.exports = __webpack_public_path__ + "img/shoplogo.59e5a015.png";